import ActionTypes from "../constants/ActionTypes";
import API from "../api/";
import _ from "lodash";

const fetchEventsRequest = () => ({
    type: ActionTypes.FETCH_EVENTS_REQUEST,
});

const fetchEventsSuccess = events => ({
    type: ActionTypes.FETCH_EVENTS_SUCCESS,
    events,
});

const fetchEventsFail = error => ({
    type: ActionTypes.FETCH_EVENTS_FAIL,
    error,
});

export const fetchEvents = () => (dispatch, getState) => {
    const events = getState().events.events;
    if (!_.isEmpty(events)) {
        return Promise.resolve();
    }
    dispatch(fetchEventsRequest());
    return API.fetchEvents()
        .then(data => {
            dispatch(fetchEventsSuccess(data));
            return data;
        })
        .catch(error => {
            dispatch(fetchEventsFail(error));
            throw error;
        });
};
